import { useState } from "react";
import { hotTags } from "@/mocks/chigua";

interface HeroProps {
  onSearch: (kw: string) => void;
}

export default function Hero({ onSearch }: HeroProps) {
  const [value, setValue] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(value);
  };

  const pickTag = (t: string) => {
    onSearch(t);
  };

  const stats = [
    { num: "10", unit: "万+", label: "网友每日到访吃瓜" },
    { num: "128", unit: "篇", label: "事件深度盘点专题" },
    { num: "36", unit: "条", label: "今日实时情报速递" },
  ];

  return (
    <section id="top" className="relative flex min-h-[92vh] items-center overflow-hidden pt-20">
      {/* background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylish%20artistic%20illustration%20of%20giant%20watermelon%20halves%20and%20juicy%20melon%20slices%20floating%20with%20news%20headline%20cards%20and%20hashtag%20badges%2C%20playful%20magazine%20collage%20in%20coral%20red%20mint%20green%20and%20amber%20on%20a%20warm%20cream%20background%2C%20dynamic%20scattered%20composition%2C%20high%20energy%20youthful%20editorial%20style&width=1920&height=1080&seq=hero-melon-2026&orientation=landscape"
          alt="吃瓜中心热点情报站概念插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/55 via-background-50/35 to-background-50"></div>
      </div>

      <div className="chigua-container relative mx-auto w-full">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-xs font-semibold text-primary-700 backdrop-blur">
            <i className="ri-flashlight-fill"></i> 今日情报 · 每天 08:00 准时开播
          </span>

          <h1 className="mt-6 font-display text-4xl leading-tight text-foreground-900 sm:text-5xl md:text-6xl">
            把瓜吃明白，<br className="sm:hidden" />
            把热点看清楚
          </h1>
          <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-foreground-600 md:text-base">
            吃瓜中心情报站，每日快速整理全网热点事件脉络。事件盘点速递、时间线梳理与深度分析，
            帮你从海量信息里提炼关键要点，突发爆料、持续发酵还是反转复盘，一站看全。
          </p>

          {/* Search */}
          <form
            onSubmit={submit}
            className="mt-8 flex w-full max-w-xl items-center gap-2 rounded-full border border-background-200 bg-background-50/90 p-1.5 pl-4 shadow-none backdrop-blur md:gap-3"
            role="search"
          >
            <i className="ri-search-line shrink-0 text-base text-foreground-400"></i>
            <input
              type="text"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              name="keyword"
              placeholder="输入事件关键词，例如：综艺、联名、翻车…"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="shrink-0 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:px-6"
            >
              检索情报
            </button>
          </form>

          {/* hot tags */}
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-foreground-500">正在热议</span>
            {hotTags.slice(0, 4).map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => pickTag(t)}
                className="chip chip-idle"
              >
                <i className="ri-fire-line mr-1 text-primary-500"></i>
                {t}
              </button>
            ))}
          </div>

          {/* stats */}
          <dl className="mt-10 grid w-full max-w-2xl grid-cols-1 gap-3 rounded-3xl border border-background-200 bg-background-50/70 p-4 backdrop-blur sm:grid-cols-3 md:p-6">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center px-2 text-center">
                <dt className="sr-only">{s.label}</dt>
                <dd className="font-display text-2xl text-primary-600 md:text-3xl">
                  {s.num}
                  <span className="text-base text-primary-500">{s.unit}</span>
                </dd>
                <dd className="mt-1 text-xs text-foreground-500">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      {/* scroll hint */}
      <a
        href="#hot"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-foreground-400 transition-colors hover:text-primary-600"
        aria-label="向下浏览"
      >
        <i className="ri-arrow-down-double-line text-xl animate-bounce"></i>
      </a>
    </section>
  );
}